<template>
	<div class="topMenus">
		<div class="m-item" v-for="(item,index) in navItems" :key="index" :class="{ active: currentIndex === index }">
			<div @click="changeNav(index,item)">{{item.label}} <i class="el-icon-arrow-down m-icon" v-if="item.subMenus && item.subMenus.length>0"></i></div>
			<div class="subContent" v-if="item.subMenus && item.subMenus.length>0">
				<i class="el-icon-caret-top icon-top"></i>
				<div class="subMenus">
					<span class="subItem" @click="changeNav(index,item,subIndex)" v-for="(subItem,subIndex) in item.subMenus" :key="subIndex">{{subItem.title}}</span>
				</div>
			</div>
		</div>
		<img src="../../static/logo.png" class="logo"/>
	</div>
</template>
<script>
	import { eventBus } from '@/main.js'
	export default {
		data() {
			return {
				activeIndex: '0',
				// mouseOverOnIndex: null,
			};
		},
		props:{
			navItems:{
				type:Array,
				require:true
			},
			currentIndex:{
				type:Number
			}
		},
		methods: {
			changeNav(index,item,subIndex){
				// this.mouseOverOnIndex = null
				// this.activeIndex = index;
				if(subIndex>=0){
					this.$root.subMenuIndex = subIndex ;
				}
				if(this.$route.name == item.componentName) return;
				this.$router.replace({path:'/'+item.componentName})
				this.$emit('changeTab',"/"+item.componentName)
				// eventBus.$emit('leftMenuClick',index);
			}
		}
	}
</script>
<style lang="less">
	@import '../assets/css/index';
	@import '../assets/css/style';
	
	.topMenus{
		position: relative;
		height: auto;
		margin: 40/@r auto;
		width: 1680/@r;
		.logo {
			margin-right: 0;
			position: absolute;
			right: 0;
			top: 0;
			width: 200/@r;
			height: 40/@r;
		}
		.m-item{
			float: left;
			display: inline-block;
			height: 40/@r  !important;
			line-height: 40/@r  !important;
			font-size: 18/@r;
			margin-right: 14/@r !important;
			position: relative;
			.subContent{
				position: absolute;
				width: 222/@r;
				display: none;
				.pos-a(25, -69, 4);
				.icon-top{
					.pos-a-center();
					color: #000000;
				}
				.subMenus{
					position: absolute;
					width: 222/@r;
					min-height: 120/@r;
					// .scale(202,169) !important;
					color: #b2b1b1;
					background: rgba(0,0,0,0.9);
					.pos-a(11, 0, 4);
					border-radius: 20/@r;
					text-align: center;
					.subItem{
						display: block;
						// line-height: 45/@r;
						margin: 15/@r auto;
						&:hover{
							color: #fff;
							cursor: pointer;
						}
					}
				}
			}
			&.active{
				color: #3f8eba;
				font-weight: bold;
			}
			&:hover{
				color: #3f8eba;
				font-weight: bold;
				.subContent{
					display: block;
				}
			}
			
			&:first-child{
				margin-right: 32/@r !important;
			}
		}
		.m-icon{
			  color: #3f8eba;
			  font-weight: bold;
		}
	}
</style>
